import { Pipe, inject, type PipeTransform } from '@angular/core';

import { BrandingService } from './branding.service.js';

/**
 * Template pipe that returns the current brand name. Use when you need
 * the brand name inline in a template without an @Input:
 *
 * ```html
 * <h1>Welcome to {{ null | brandName }}</h1>
 * ```
 *
 * Impure so it reacts to `BrandingService.apply()` calls at runtime.
 */
@Pipe({ name: 'brandName', pure: false })
export class BrandNamePipe implements PipeTransform {
  private readonly branding = inject(BrandingService);

  transform(): string {
    return this.branding.name();
  }
}
